module.exports = "/static/assets/0bd32feab34717d83b8edcf777c81a63.png";